import s from './Downloads.module.css';

const Downloads = () => <div className={s.containerCabinet}>Downloads</div>
        
export default Downloads;
